import { combineReducers, createStore as createReduxStore } from 'redux';
import { pickBy, isEmpty } from 'lodash';
import { installState } from '../state/install-state';
import { Core } from '../core/core';

/**
 * Memo reducer from collection responses
 *
 * @param {*} [state={}]
 * @param {*} action
 * @returns
 */
function _memo_cache(state = {}, action) {
    switch (action.type) {
        case 'MEMO_UPDATE':
            return { ...state, [action.key]: action.value };
        case 'MEMO_REMOVE':
            return {
                ...pickBy(state, (it, key) => {
                    return key !== action.key;
                }),
            };
        case 'MEMO_RESET':
            return {};
        default:
            return state;
    }
}

/**
 * Create redux store
 * @example
 *  // logger middleware example
 *   const logger = store => next => action => {
 *   console.log('dispatching', action);
 *   const result = next(action);
 *   console.log('next state', store.getState());
 *   return result;
 *  };
 *
 *  // create store outside app.module
 *  createStore(
 *    // list of reducers
 *    { counter },
 *    // initial state
 *    { counter: 420 },
 *    // composing enhancers
 *    compose(applyDevTools(), applyMiddleware(logger))
 *  );
 *  store().subscribe(it => console.log(it, store().getState()));
 *
 * @export
 * @param {*} reducers
 * @param {*} initialState
 * @param {*} [enhancers]
 */
export function createStore(reducers, enhancers?);
export function createStore(reducers, initialState?, enhancers?);
export function createStore(reducers, initialState?, enhancers?) {
    if (!isEmpty(Core.store)) {
        console.warn(`oops looks like there's a store created already`);
    }
    installState();

    Core.store = createReduxStore(combineReducers({ _memo_cache, ...reducers }), initialState, enhancers);
    return Core.store;
}
